import { StyleSheet } from 'aphrodite/no-important';
import { IGenericObject } from 'models/base';
import { children, media, palette } from 'util/style-helpers';

export const style: any = (styles: IGenericObject) => {
  return StyleSheet.create({
    container: {
      height: '100%',
      width: '100%',
      display: 'flex',
      flexWrap: 'nowrap',
      flexDirection: 'column',
      alignItems: 'center',
      textAlign: 'center',
    },
    headline: {
      fontSize: 25,
      lineHeight: 35 / 25,
      fontWeight: 'bold',
      marginBottom: 20,
      [media.desktop]: {
        fontSize: 40,
        lineHeight: 50 / 40,
        marginBottom: 30,
      },
      [media.tablet]: {
        fontSize: 35,
        lineHeight: 45 / 35,
        marginBottom: 30,
      },
    },
    icon: {
      margin: 20,
      [children('svg')]: {
        height: 74,
        width: 'auto',
        [media.tablet]: {
          height: 87,
        },
      },
      [children('path')]: {
        fill: palette.red,
      },
    },
    message: {
      fontSize: 16,
      lineHeight: 20 / 16,
      marginBottom: 30,
      [children('p')]: {
        margin: 0,
      },
      [media.tablet]: {
        fontSize: 24,
        lineHeight: 28 / 24,
      },
    },
    button: {
      background: `linear-gradient(180deg, ${palette.red} 0%, ${palette.darkRed} 100%)`,
      color: palette.white,
      fontSize: 17,
      lineHeight: 20 / 17,
      fontWeight: 'bold',
      padding: '20px 35px',
      borderRadius: 5,
      border: 'none',
      [media.tablet]: {
        padding: '16px 22px',
        fontSize: 24,
        lineHeight: 29 / 24,
      },
      [media.desktop]: {
        padding: '16px 19px',
        backgroundColor: palette.red,
      },
    },
  });
};
